import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import { withRouter } from '@bibliocommons/utils-routing';
import { routerShape } from '@bibliocommons/bc-prop-types';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { searchEventComposer } from '@bibliocommons/analytics-event-composers';
import updateSearchQuery from '../../helpers/search/updateSearchQuery';

import './DidYouMean.scss';

export class DidYouMean extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick(e) {
    e.preventDefault();
    const { router, emptySearch } = this.props;
    sendAnalyticsEvents(
      searchEventComposer.composeDidYouMeanClickEvent({
        query: router.query.query,
        suggestion: this.props.querySuggestion,
        emptySearch
      })
    );

    const query = updateSearchQuery({
      currentQuery: router.query,
      query: this.props.querySuggestion,
      page: undefined
    });

    router.push({ query });
  }

  render() {
    const { querySuggestion, resultCount } = this.props;
    if (!querySuggestion) {
      return null;
    }

    return (
      <div className="cp-did-you-mean">
        <FormattedMessage
          id="form_label_did_you_mean"
          values={{ querySuggestion: <strong>{querySuggestion}</strong> }}
        />
        &nbsp;
        <a className="did-you-mean-suggestion-link" href="#dym" onClick={this.handleClick}>
          <FormattedMessage id="form_label_did_you_mean_view_results" values={{ resultCount }} />
        </a>
      </div>
    );
  }
}

DidYouMean.displayName = 'DidYouMean';

DidYouMean.propTypes = {
  emptySearch: PropTypes.bool,
  querySuggestion: PropTypes.string,
  resultCount: PropTypes.number,
  router: routerShape.isRequired
};

export default withRouter(DidYouMean);
